import { PriceDisplay, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const DateSpan = styled.span`
  ${typographyV2.bodyXs}
  color: var(--text-soft);
`;

export const StyledPriceDisplay = styled(PriceDisplay)<{
  $isHorizontalView?: boolean;
  $showPricePercentage?: boolean;
  $showDotSeparator?: boolean;
}>`
  ${PriceDisplay.Styled.Price} {
    ${({ $isHorizontalView }) =>
      $isHorizontalView ? typographyV2.bodySm : typographyV2.titleLg}
  }

  ${PriceDisplay.Styled.OutsideHoursTag} {
    margin-right: ${({ $isHorizontalView }) =>
      $isHorizontalView ? 0 : '12px'};
  }

  ${PriceDisplay.Styled.Currency} {
    ${typographyV2.bodyXXs};
  }

  ${PriceDisplay.Styled.PercentageChangeLabel} {
    ${({ $showPricePercentage }) =>
      !$showPricePercentage &&
      css`
        display: none;
      `}
  }

  ${({ $isHorizontalView }) =>
    $isHorizontalView &&
    css`
      && {
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 8px;
      }
    `}

  ${({ $showDotSeparator, $isHorizontalView }) =>
    $showDotSeparator &&
    $isHorizontalView &&
    css`
      ${PriceDisplay.Styled.LabelsContainer}::before {
        content: '';
        width: 2px;
        height: 2px;
        border-radius: 50%;
        background-color: var(--icon-soft);
        display: flex;
        align-self: center;
        margin-right: 8px;
      }
    `}
`;
